
const createemprecord = {
  label: "Create Employee Record",
  pageLabel: "Create Employee Record",
  starting: true,
  url: "createemprecord",
  pageType: "history",
  formTabs: {
    allTabs: [
      {
        label: "User Information",
        uid: "userinfo",
        style: { fontFamily: "verdana" }
      },
       { label: "Address & Contact", uid: "addresscontact", style: { fontFamily: "verdana" } },
    ]
  },
  form: [
    {
      widths: "col-sm-12",
      tab: "userinfo",
      subComponents: [
        {
          inputType: "displaytext",
          isRequired: true,
          widths: {
            parent: "col-sm-12",
            children: "col-sm-12"
          },
          placeHolder: "",
          label: "Name",
          name: "",
          description: ""
        },

        {
          inputType: "displaytext",
          isRequired: true,
          widths: {
            parent: "col-sm-2",
            children: "col-sm-12"
          },
          placeHolder: "Branch",
          label: "Branch",
          name: "branch",
          description: "Enter Branch"
        },
        {
          inputType: "autocomplete",
          default: "",
          elementProps: {
            stayOpen: false,
            removeSelected: true,
            disabled: false,
            rtl: false
          },
          widths: {
            parent: "col-sm-2",
            children: "col-sm-12"
          },
          ajaxLoad: true,
          ajaxOptions: {
            value: "code",
            label: "descn",
            query: {
              dialect: "mysql",
              query: "getBranchName"
            }
          },
          options: [
            {
              label:"branch1",
              value:"baranch"
            }
          ],
          //prepend:"Br.Name";
          placeHolder: "Branch ",
          name: "branch",
          description: "Enter 4 digit Branch Code"
        },
        {
          inputType: "showdata",
          data: "branch",
          textcolor: "black",
          widths: {
            parent: "col-sm-2",
            children: "col-sm-12"
          }
        },
        {
          inputType: "displaytext",
          isRequired: true,
          widths: {
            parent: "col-sm-6",
            children: "col-sm-12"
          },
          placeHolder: "",
          label: "",
          name: "",
          description: ""
        },
        {
          inputType: "displaytext",
          isRequired: true,
          widths: {
            parent: "col-sm-2",
            children: "col-sm-12"
          },
          placeHolder: "Employee",
          label: "Employee",
          name: "Employee",
          description: "Enter Employee"
        },
        {
          inputType: "text",
          isRequired: true,
          widths: {
            parent: "col-sm-2",
            children: "col-sm-12"
          },
          placeHolder: "Employee",
          name: "Employee",
          description: "Enter Employee"
        },
        {
          inputType: "displaytext",
          isRequired: true,
          widths: {
            parent: "col-sm-8",
            children: "col-sm-12"
          },
          placeHolder: "",
          label: "",
          name: "",
          description: ""
        },
        {
          inputType: "displaytext",
          isRequired: true,
          widths: {
            parent: "col-sm-2",
            children: "col-sm-12"
          },
          placeHolder: "Title",
          label: "Title",
          name: "Title",
          description: "Enter Title"
        },
        {
          inputType: "select",
          isRequired: true,
          widths: {
            parent: "col-sm-2",
            children: "col-sm-12"
          },
          options: [
            {
              label: "Miss",
              value: "Miss."
            },
            {
              label: "Mr",
              value: "Mr."
            },
            {
              label: "Dr",
              value: "Dr."
            },
            {
              label: "Master",
              value: "Master."
            }
          ],
          placeHolder: "Title",
          name: "Title",
          description: "Enter Title"
        },
        {
          inputType: "displaytext",
          isRequired: true,
          widths: {
            parent: "col-sm-8",
            children: "col-sm-12"
          },
          placeHolder: "",
          label: "",
          name: "",
          description: ""
        },
        {
          inputType: "displaytext",
          isRequired: true,
          widths: {
            parent: "col-sm-2",
            children: "col-sm-12"
          },
          placeHolder: "First Name",
          label: "First Name",
          name: "firstname",
          description: "Enter First Name"
        },
        {
          inputType: "text",
          isRequired: true,
          widths: {
            parent: "col-sm-4",
            children: "col-sm-12"
          },
          placeHolder: "First Name",
          name: "firstname",
          description: "Enter First Name"
        },
        {
            inputType: "displaytext",
            isRequired: true,
            widths: {
              parent: "col-sm-6",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "",
            name: "",
            description: ""
          },
          {
            inputType: "displaytext",
            isRequired: true,
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "Last Name",
            label: "Last Name",
            name: "lastname",
            description: "Enter Last Name"
          },
          {
            inputType: "text",
            isRequired: true,
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "Last Name",
            name: "lastname",
            description: "Enter Last Name"
          },
          {
              inputType: "displaytext",
              isRequired: true,
              widths: {
                parent: "col-sm-6",
                children: "col-sm-12"
              },
              placeHolder: "",
              label: "",
              name: "",
              description: ""
            },
            {
                inputType: "displaytext",
                isRequired: true,
                widths: {
                  parent: "col-sm-2",
                  children: "col-sm-12"
                },
                placeHolder: "Display Name",
                label: "Display Name",
                name: "displayname",
                description: "Enter Display Name"
              },
              {
                inputType: "text",
                isRequired: true,
                widths: {
                  parent: "col-sm-4",
                  children: "col-sm-12"
                },
                placeHolder: "Display Name",
                name: "displayname",
                description: "Enter Display Name"
              },
              {
                inputType: "displaytext",
                isRequired: true,
                widths: {
                  parent: "col-sm-6",
                  children: "col-sm-12"
                },
                placeHolder: "",
                label: "",
                name: "",
                description: ""
              },
        {
          inputType: "displaytext",
          isRequired: true,
          widths: {
            parent: "col-sm-2",
            children: "col-sm-12"
          },
          placeHolder: "Initials",
          label: "Initials",
          name: "Initials",
          description: "Enter Initials"
        },
        {
          inputType: "text",
          isRequired: true,
          widths: {
            parent: "col-sm-2",
            children: "col-sm-12"
          },
          placeHolder: "Initials",
          name: "Initials",
          description: "Enter Initials"
        },
        {
            inputType: "displaytext",
            isRequired: true,
            widths: {
              parent: "col-sm-8",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "",
            name: "",
            description: ""
          },

        {
            inputType: "checkbox",
            isRequired: true,
            default: "false",
            widths: {
              parent: "col-sm-12",
              children: "col-sm-12"
            },
            placeHolder: "Set Active",
            label: "Set Active",
            name: "setactive",
            description: "Active"
          },
      ]
    },
    {
        widths: "col-sm-12",
        tab: "userinfo",
        subComponents: [
            {
                inputType: "displaytext",
                isRequired: true,
                widths: {
                  parent: "col-sm-12",
                  children: "col-sm-12"
                },
                placeHolder: "",
                label: "Login Name And Password",
                name: "",
                description: ""
              },
              {
                inputType: "displaytext",
                isRequired: true,
                widths: {
                  parent: "col-sm-2",
                  children: "col-sm-12"
                },
                placeHolder: "Login Name",
                label: "Login Name",
                name: "loginname",
                description: "Enter Login Name"
              },
              {
                inputType: "text",
                isRequired: true,
                widths: {
                  parent: "col-sm-4",
                  children: "col-sm-12"
                },
                placeHolder: "Login Name",
                name: "loginname",
                description: "Enter Login Name"
              },
              {
                inputType: "displaytext",
                isRequired: true,
                widths: {
                  parent: "col-sm-6",
                  children: "col-sm-12"
                },
                placeHolder: "",
                label: "",
                name: "",
                description: ""
              },
              {
                inputType: "displaytext",
                isRequired: true,
                widths: {
                  parent: "col-sm-2",
                  children: "col-sm-12"
                },
                placeHolder: "Password",
                label: "Password",
                name: "Password",
                description: "Enter Password"
              },
              {
                inputType: "text",
                isRequired: true,
                widths: {
                  parent: "col-sm-2",
                  children: "col-sm-12"
                },
                placeHolder: "Password",
                name: "Password",
                description: "Enter Password"
              },
              {
                inputType: "displaytext",
                isRequired: true,
                widths: {
                  parent: "col-sm-8",
                  children: "col-sm-12"
                },
                placeHolder: "",
                label: "",
                name: "",
                description: ""
              },
              {
                inputType: "displaytext",
                isRequired: true,
                widths: {
                  parent: "col-sm-2",
                  children: "col-sm-12"
                },
                placeHolder: "Repeat Password",
                label: "Repeat Password",
                name: "Repeat_Password",
                description: "Enter Repeat Password"
              },
              {
                inputType: "text",
                isRequired: true,
                widths: {
                  parent: "col-sm-2",
                  children: "col-sm-12"
                },
                placeHolder: "Repeat Password",
                name: "Repeat_Password",
                description: "Enter Repeat Password"
              },
              {
                inputType: "displaytext",
                isRequired: true,
                widths: {
                  parent: "col-sm-8",
                  children: "col-sm-12"
                },
                placeHolder: "",
                label: "",
                name: "",
                description: ""
              },
              {
                inputType: "displaytext",
                isRequired: true,
                widths: {
                  parent: "col-sm-2",
                  children: "col-sm-12"
                },
                placeHolder: "",
                label: "Validity",
                name: "",
                description: ""
              },
              {
                inputType: "date",
                dateType: "ontype",
                isRequired: true,
                widths: {
                  parent: "col-sm-2",
                  children: "col-sm-12"
                },
                displayFormat: "DD/MM/YYYY",
                outputFormat: "YYYYMMDD",
                placeHolder: "",
                label: "",
                name: "validityfrom",
                description: ""
              },
              {
                inputType: "date",
                dateType: "ontype",
                isRequired: true,
                widths: {
                  parent: "col-sm-2",
                  children: "col-sm-12"
                },
                displayFormat: "DD/MM/YYYY",
                outputFormat: "YYYYMMDD",
                placeHolder: "",
                label: "",
                name: "validityto",
                description: ""
              },
        ]
    },
    {
        widths: "col-sm-12",
        tab: "addresscontact",
        subComponents: [
            {
                inputType: "displaytext",
                isRequired: true,
                widths: {
                  parent: "col-sm-12",
                  children: "col-sm-12"
                },
                placeHolder: "",
                label: "Contact Address",
                name: "",
                description: ""
              },
              {
                inputType: "displaytext",
                isRequired: true,
                widths: {
                  parent: "col-sm-2",
                  children: "col-sm-12"
                },
                placeHolder: "Address Type",
                label: "Address Type",
                name: "Address_Type",
                description: "Enter Address Type"
              },
              {
                inputType: "select",
                isRequired: true,
                widths: {
                  parent: "col-sm-2",
                  children: "col-sm-12"
                },
                options: [
                  {
                    label: "Permament",
                    value: "Permament."
                  },
                  {
                    label: "Correspondance",
                    value: "Correspondance."
                  },
                  {
                    label: "Office",
                    value: "Office."
                  },
                  
                ],
                placeHolder: "Address Type",
                name: "Address_Type",
                description: "Enter Address Type"
              },
              {
                inputType: "displaytext",
                isRequired: true,
                widths: {
                  parent: "col-sm-8",
                  children: "col-sm-12"
                },
                placeHolder: "",
                label: "",
                name: "",
                description: ""
              },
              {
                inputType: "displaytext",
                isRequired: true,
                widths: {
                  parent: "col-sm-2",
                  children: "col-sm-12"
                },
                placeHolder: "",
                label: "C/O",
                name: "",
                description: ""
              },
              {
                inputType: "text",
                isRequired: true,
                widths: {
                  parent: "col-sm-4",
                  children: "col-sm-12"
                },
                placeHolder: "",
                label: "",
                name: "co",
                description: ""
              },
              {
                inputType: "displaytext",
                isRequired: true,
                widths: {
                  parent: "col-sm-6",
                  children: "col-sm-12"
                },
                placeHolder: "",
                label: "",
                name: "",
                description: ""
              },
              {
                inputType: "displaytext",
                isRequired: true,
                widths: {
                  parent: "col-sm-2",
                  children: "col-sm-12"
                },
                placeHolder: "Address",
                label: "Address",
                name: "Address",
                description: "Address"
              },
              {
                inputType: "text",
                isRequired: true,
                widths: {
                  parent: "col-sm-4",
                  children: "col-sm-12"
                },
                placeHolder: "Address",
                label: "",
                name: "Address",
                description: "Enter Address"
              },
              {
                inputType: "displaytext",
                isRequired: true,
                widths: {
                  parent: "col-sm-6",
                  children: "col-sm-12"
                },
                placeHolder: "",
                label: "",
                name: "",
                description: ""
              },
              {
                inputType: "displaytext",
                isRequired: true,
                widths: {
                  parent: "col-sm-2",
                  children: "col-sm-12"
                },
                placeHolder: "City/Pin Code",
                label: "City/Pin Code",
                name: "citypin",
                description: "City/Pin Code"
              },
              {
                inputType: "text",
                isRequired: true,
                widths: {
                  parent: "col-sm-2",
                  children: "col-sm-12"
                },
                placeHolder: "",
                label: "",
                name: "city",
                description: "Enter City"
              },
              {
                inputType: "text",
                isRequired: true,
                widths: {
                  parent: "col-sm-2",
                  children: "col-sm-12"
                },
                placeHolder: "",
                label: "",
                name: "pin",
                description: "Enter Pin"
              },
              {
                inputType: "displaytext",
                isRequired: true,
                widths: {
                  parent: "col-sm-6",
                  children: "col-sm-12"
                },
                placeHolder: "",
                label: "",
                name: "",
                description: ""
              },
              {
                inputType: "displaytext",
                isRequired: true,
                widths: {
                  parent: "col-sm-2",
                  children: "col-sm-12"
                },
                placeHolder: "",
                label: "Country",
                name: "",
                description: ""
              },
              {
                inputType: "text",
                isRequired: true,
                widths: {
                  parent: "col-sm-2",
                  children: "col-sm-12"
                },
                placeHolder: "",
                label: "",
                name: "Country",
                description: "Enter Country"
              },
        ]
    },
    {
        widths: "col-sm-12",
        tab: "addresscontact",
        subComponents: [
            {
                inputType: "displaytext",
                isRequired: true,
                widths: {
                  parent: "col-sm-12",
                  children: "col-sm-12"
                },
                placeHolder: "",
                label: "Communication",
                name: "",
                description: ""
              },
              {
                inputType: "displaytext",
                isRequired: true,
                widths: {
                  parent: "col-sm-2",
                  children: "col-sm-12"
                },
                placeHolder: "Home Telephone",
                label: "Home Telephone",
                name: "homephone",
                description: "Enter Home Telephone"
              },
              {
                inputType: "text",
                isRequired: true,
                widths: {
                  parent: "col-sm-2",
                  children: "col-sm-12"
                },
             // validations: [{ rule: mobileNumber, message: "number not valid " }],

                placeHolder: "Home Telephone",
                label: "",
                name: "homephone",
                description: "Enter Home Telephone"
              },
              {
                inputType: "displaytext",
                isRequired: true,
                widths: {
                  parent: "col-sm-8",
                  children: "col-sm-12"
                },
                placeHolder: "",
                label: "",
                name: "",
                description: ""
              },
              {
                inputType: "displaytext",
                isRequired: true,
                widths: {
                  parent: "col-sm-2",
                  children: "col-sm-12"
                },
                placeHolder: "Mobile Number",
                label: "Mobile Number",
                name: "mobilenum",
                description: "Mobile Number"
              },
              {
                inputType: "text",
                isRequired: true,
                widths: {
                  parent: "col-sm-2",
                  children: "col-sm-12"
                },
                               // validations: [{ rule: mobileNumber, message: "number not valid " }],

                placeHolder: "Mobile Number",
                label: "",
                name: "mobilenum",
                description: "Enter Mobile Number"
              },
              {
                inputType: "displaytext",
                isRequired: true,
                widths: {
                  parent: "col-sm-8",
                  children: "col-sm-12"
                },
                placeHolder: "",
                label: "",
                name: "",
                description: ""
              },
              {
                inputType: "displaytext",
                isRequired: true,
                widths: {
                  parent: "col-sm-2",
                  children: "col-sm-12"
                },
                placeHolder: "Office Telephone",
                label: "Office Telephone",
                name: "officephone",
                description: "Office Telephone"
              },
              {
                inputType: "text",
                isRequired: true,
                widths: {
                  parent: "col-sm-2",
                  children: "col-sm-12"
                },
                               // validations: [{ rule: mobileNumber, message: "number not valid " }],

                placeHolder: "Office Telephone",
                label: "",
                name: "offciephone",
                description: "Enter Office Telephone"
              },
              {
                inputType: "displaytext",
                isRequired: true,
                widths: {
                  parent: "col-sm-8",
                  children: "col-sm-12"
                },
                placeHolder: "",
                label: "",
                name: "",
                description: ""
              },
              {
                inputType: "displaytext",
                isRequired: true,
                widths: {
                  parent: "col-sm-2",
                  children: "col-sm-12"
                },
                placeHolder: "Office E-mail",
                label: "Office E-mail",
                name: "officeemail",
                description: "Enter Office E-mail"
              },
              {
                inputType: "text",
                isRequired: true,
                widths: {
                  parent: "col-sm-3",
                  children: "col-sm-12"
                },
                // validations: [{ rule: validEmail, message: "Email not valid " }],
                placeHolder: "Office E-mail",
                label: "",
                name: "offcieemail",
                description: "Enter Office E-mail"
              },
        ]
    }
  ]
};
export default createemprecord;
